import type { Coordinate, Sort } from '.';
import type { UUID } from './identifier';

enum GeofenceType {
  BASE = 'BASE',
  CLIENT = 'CLIENT',
  OTHER = 'OTHER',
  HEADQUARTER = 'HEADQUARTER',
  SUPPLY = 'SUPPLY',
  MAINTENANCE = 'MAINTENANCE',
}

enum GeofenceFormat {
  CIRCLE = 'CIRCLE',
  RECTANGLE = 'RECTANGLE',
  DRAWING = 'DRAWING',
}

enum PointOnMapType {
  DESTINATION = 'DESTINATION',
  GEOFENCE = 'GEOFENCE',
  SEARCH = 'SEARCH',
}

interface GeofenceGeometryPolygon {
  type: 'Polygon';
  coordinates: [number[][]];
}

interface GeofenceGeometryPoint {
  type: 'Point';
  coordinates: [number, number];
}

interface GeofenceProperties {
  id: UUID;
  type: GeofenceType;
}

interface GeofenceFilter {
  page?: number;
  search?: string;
  size?: number;
  sort?: Sort[];
}

interface GeofenceMapPoint {
  type: 'Feature';
  geometry: GeofenceGeometryPoint;
  properties: GeofenceProperties;
}

interface GeofenceResume {
  id: UUID;
  lat: number;
  lng: number;
  type: GeofenceType;
}

interface PlainGeofence {
  id: UUID;
  name: string;
  type: GeofenceType;
  format?: GeofenceFormat;
  radius?: number;
  address: string;
  geometryPoint: GeofenceGeometryPoint;
  geometryPolygon: GeofenceGeometryPolygon;
  area: number;
}

interface PointOnMap {
  address?: string;
  center?: Coordinate;
  type?: PointOnMapType;
}

interface Geofence extends PlainGeofence {
  geometry: GeofenceGeometryPolygon;
  properties: GeofenceProperties;
}

interface GeofenceValidationQuery {
  name: string;
  address: string;
}

export { GeofenceType, GeofenceFormat, PointOnMapType };

export type {
  Geofence,
  GeofenceFilter,
  GeofenceGeometryPoint,
  GeofenceGeometryPolygon,
  GeofenceMapPoint,
  GeofenceResume,
  GeofenceProperties,
  GeofenceValidationQuery,
  PlainGeofence,
  PointOnMap,
};
